import React from 'react';
import { useTranslation } from '@rbx/intl';

type TranslationNamespaceTranslation = {
  keyName: string; // translation key to use translation of from a loaded translation namespace
  args?: {
    [key: string]: string;
  }; // arguments to pass to translation function 2nd parameter
};

// TODO (@ahua): Implement post-CMS integration
// type MarkdownPageFrontmatterTranslation = {
//   href: string; // relative path to docs page link
//   frontmatterKey: string; // key to frontmatter value to use translation of
// };
// const isTranslationNamespaceTranslationProps = (
//   props: unknown
// ): props is TranslationNamespaceTranslation => {
//   return (props as TranslationNamespaceTranslation).key !== undefined;
// };
// const isMarkdownFrontmatterTranslationProps = (
//   props: unknown
// ): props is MarkdownPageFrontmatterTranslation => {
//   return (
//     (props as MarkdownPageFrontmatterTranslation).href !== undefined &&
//     (props as MarkdownPageFrontmatterTranslation).frontmatterKey !== undefined
//   );
// };

const MarkdownTranslation = ({ keyName, args }: TranslationNamespaceTranslation) => {
  // returns a plain string that is a translation from translation resources
  const { translate } = useTranslation();

  return <React.Fragment>{translate(keyName, args)}</React.Fragment>;
};

export default MarkdownTranslation;
